import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  createLicenseUserOneTimePassword,
  deleteLicenseUser,
  fetchLicenseUsers,
} from '../../actions';
import CreateUser from './CreateUser';
import { useLocation, useNavigate } from 'react-router-dom';
import ShowPassword from './ShowPassword';
import Button from '../../../Share/components/Button';
import moment from 'moment';
import ResetPassword from './ResetPassword';
import DeleteUser from './DeleteUser';

function ManageUserList({
  users = [],
  setShowPassword = () => {},
  setShowResetPassword = () => {},
  setSelectedUser = () => {},
  location = {},
  setDeleteUser = () => {},
  numberOfActiveUsers = 0,
  numberOfLicenses = 0,
}) {
  return (
    <div className="tv-contactperson__list-wrapper">
      {users && users.length > 0 ? (
        <>
          {users.map(user => (
            <div
              key={user.UserIdentifier}
              className="row  custom tv-reportquality__list-item  mb-0"
            >
              <div className="row px-0 mx-0 w-100 tv-display-mobile-hide">
                <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl">
                  <div className=" tv-contactperson__item-text">
                    {user.UserName}
                  </div>
                </div>
                <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl ">
                  <div className="tv-contactperson__item-text tv-license__number-of-licenses">
                    {user.DatetimeLastLogin
                      ? moment(user.DatetimeLastLogin).format('YYYY-MM-DD')
                      : null}
                  </div>
                </div>
                <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl edit-contact">
                  <div className=" tv-contactperson__item-text">
                    {user.DateEnd
                      ? moment(user.DateEnd).format('YYYY-MM-DD')
                      : null}
                  </div>
                </div>
                <div className="col-12 col-xs-4  col-sm-4 col-md  col-lg col-xl ">
                  <div className="tv-contactperson__item-edit   text-center">
                    <Button
                      Text="Sätt avslutsdatum"
                      className={`tv-license__manage-license ${!user.DateEnd ? 'tv-license__active' : 'tv-license__inactive'}`}
                      onClick={() => {
                        setSelectedUser(user);
                        setDeleteUser(true);
                      }}
                      disabled={user.DateEnd}
                    />
                  </div>
                </div>
                {!user.DoShowResetPasswordLink && (
                  <div
                    className="col-12 col-xs-6  col-sm-6 col-md col-lg col-xl edit-contact"
                    onClick={() => setShowPassword(user)}
                    tabIndex={0}
                    onKeyDown={e => {}}
                    role="button"
                  >
                    <div className="tv-contactperson__item-edit   text-center">
                      Engångslösenord
                    </div>
                  </div>
                )}
                {user.DoShowResetPasswordLink && (
                  <div
                    className="col-12 col-xs-6  col-sm-6 col-md col-lg col-xl edit-contact"
                    onClick={() => {
                      setSelectedUser(user);
                      setShowResetPassword(true);
                    }}
                    tabIndex={0}
                    onKeyDown={e => {}}
                    role="button"
                  >
                    <div className="tv-contactperson__item-edit   text-center">
                      Återställ lösenordet
                    </div>
                  </div>
                )}
              </div>

              <div className="tv-contactperson-item--mobile flex-column mx-0 px-2 tv-display-mobile-show w-100 h-100">
                <div className="tv-reportquality__item-text tv-contactperson__item-text mt-2 pt-1 justify-content-between">
                  <b className="tv-workassignment__detail-status text-lowercase">
                    {user.UserName}
                  </b>
                  <div className="d-flex gap-2">
                    {!user.DoShowResetPasswordLink && (
                      <span
                        className="tv-contactperson__item-edit text-center"
                        onClick={() => setShowPassword(user)}
                        tabIndex={0}
                        role="button"
                      >
                        Engångslösenord
                      </span>
                    )}
                    {user.DoShowResetPasswordLink && (
                      <span
                        className="tv-contactperson__item-edit text-center"
                        onClick={() => {
                          setSelectedUser(user);
                          setShowResetPassword(true);
                        }}
                        tabIndex={0}
                        role="button"
                      >
                        Återställ
                      </span>
                    )}
                  </div>
                </div>

                <div className="tv-workassignment__item-text">
                  <div className="tv-workassignment__item-text-label">
                    <i className="fa fa-sign-in-alt mr-1" /> Senast inloggad:
                  </div>
                  {user.DatetimeLastLogin
                    ? moment(user.DatetimeLastLogin).format('YYYY-MM-DD')
                    : '-'}
                </div>
                <div className="tv-workassignment__item-text">
                  <div className="tv-workassignment__item-text-label">
                    <i className="fa fa-calendar-alt mr-1" /> Aktiv t.o.m:{" "}
                  </div>
                  {user.DateEnd
                    ? moment(user.DateEnd).format('YYYY-MM-DD')
                    : '-'}
                </div>
                <div className="tv-workassignment__item-text justify-content-end mt-2">
                  <Button
                    Text="Sätt avslutsdatum"
                    className={`tv-license__manage-license ${!user.DateEnd ? 'tv-license__active' : 'tv-license__inactive'}`}
                    onClick={() => {
                      setSelectedUser(user);
                      setDeleteUser(true);
                    }}
                    disabled={user.DateEnd}
                  />
                </div>
              </div>
            </div>
          ))}
          <div className="tv-contactperson__item-text d-flex justify-content-end mt-2">
            Antal aktiva användare : {numberOfActiveUsers} / {numberOfLicenses}
          </div>
        </>
      ) : (
        <div className="tv-contactperson__item-text text-center w-100 py-4">
          Inga licensierade användare
        </div>
      )}
    </div>
  );
}

function ManageUsers({
  onGetUsers = () => {},
  licenseUsers = [],
  licenses = [],
  resetPassword = () => {},
  onDeleteUser = () => {},
}) {
  const [showCreateUser, setShowCreateUser] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [password, setPassword] = React.useState('');
  const [showResetPassword, setShowResetPassword] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [deleteUser, setDeleteUser] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const currentLicense = licenses.find(
    l => l.LicenseIdentifier === location.state?.licenseIdentifier,
  );

  const numberOfActiveUsers = currentLicense
    ? currentLicense.NumberOfActiveUsers
    : (location.state?.numberOfActiveUsers || 0);

  const numberOfLicenses = currentLicense
    ? currentLicense.NumberOfLicenses
    : (location.state?.numberOfLicenses || 0);

  const licenseTypeName = currentLicense
    ? currentLicense.LicenseTypeName
    : (location.state?.licenseTypeName || 'Standard TFV');

  useEffect(() => {
    if (location.state?.licenseIdentifier) {
      onGetUsers(location.state.licenseIdentifier);
    }
  }, [location.state?.licenseIdentifier]);

  const handleShowPassword = value => {
    setPassword(value);
    setShowPassword(true);
  };

  return (
    <>
      <div className="tv-aiTalk__panel-wrapper">
        <div className="col-12 px-0 mx-0 w-100">
          <div className="w-100 d-flex align-items-center mb-3 license-header--mobile">
            <span
              onClick={() => navigate('/ai-tolk', { state: { tabIndex: 1 } })}
              style={{ cursor: 'pointer', marginRight: '15px' }}
              className="license-header__back mr-3"
            >
              <i className="fa fa-arrow-left" /> Tillbaka
            </span>
            <button
              className="tv_dashboard__add-button"
              type="button"
              onClick={() => setShowCreateUser(true)}
            >
              <i className="fa fa-plus" /> Skapa användare
            </button>
          </div>
          <h2 className="mb-0 license-header__title">Användare för {licenseTypeName}</h2>
          <div className="row tv-reportquality__list-item-parent tv-reportquality__list-item-header d-none d-md-flex mb-0 custom">
            <div className="col-12 col-xs-4 col-sm-4 col-md col-lg col-xl">
              <div className="tv-reportquality__item-text">Användarnamn</div>
            </div>
            <div className="col-12 col-xs-4 col-sm-4 col-md col-lg col-xl">
              <div className="tv-reportquality__item-text">Senast inloggad</div>
            </div>
            <div className="col-12 col-xs-4 col-sm-4 col-md col-lg col-xl edit-contact">
              <div className="tv-reportquality__item-text">Aktiv t.o.m</div>
            </div>
            <div className="col-12 col-xs-6 col-sm-6 col-md col-lg col-xl">
              <div className="tv-reportquality__item-text" />
            </div>
            <div className="col-12 col-xs-6 col-sm-6 col-md col-lg col-xl">
              <div className="tv-reportquality__item-text" />
            </div>
          </div>
          <ManageUserList
            users={licenseUsers}
            setShowPassword={handleShowPassword}
            setShowResetPassword={setShowResetPassword}
            setSelectedUser={setSelectedUser}
            location={location}
            setDeleteUser={setDeleteUser}
            numberOfActiveUsers={numberOfActiveUsers}
            numberOfLicenses={numberOfLicenses}
          />
        </div>
      </div>
      <CreateUser
        isVisible={showCreateUser}
        onClose={() => setShowCreateUser(false)}
        licenseIdentifier={location.state?.licenseIdentifier}
      />
      <ShowPassword
        isVisible={showPassword}
        onClose={() => setShowPassword(false)}
        details={password}
      />
      <ResetPassword
        isVisible={showResetPassword}
        onClose={() => setShowResetPassword(false)}
        userName={selectedUser?.UserName}
        onClick={() => {
          resetPassword(
            selectedUser.UserIdentifier,
            location.state?.licenseIdentifier,
          );
          setShowResetPassword(false);
        }}
      />
      <DeleteUser
        isVisible={deleteUser}
        onClose={() => {
          setDeleteUser(false);
          setSelectedUser(null);
        }}
        onDeleteUser={selectedDate => {
          onDeleteUser(
            selectedUser.UserIdentifier,
            moment(selectedDate).format('YYYY-MM-DD'),
            location.state?.licenseIdentifier,
          );
          setDeleteUser(false);
          setSelectedUser(null);
        }}
        selectedUser={selectedUser}
        dateFirstCancellationPossible={
          location.state?.dateFirstCancellationPossible
        }
      />
    </>
  );
}

ManageUsers.prototype = {
  onGetUsers: PropTypes.func,
  licenseUsers: PropTypes.arrayOf(PropTypes.shape({})),
  resetPassword: PropTypes.func,
};

const mapStateToProps = state => ({
  licenseUsers: state.user.licenseUsers,
  licenses: state.user.profile.licenses || [],
});
const mapDispatchToProps = dispatch => ({
  onGetUsers: licenseIdentifier => {
    dispatch(fetchLicenseUsers(licenseIdentifier));
  },
  resetPassword: (userIdentifier, licenseIdentifier) => {
    dispatch(
      createLicenseUserOneTimePassword(userIdentifier, licenseIdentifier),
    );
  },
  onDeleteUser: (userIdentifier, dateEnd, licenseIdentifier) => {
    dispatch(deleteLicenseUser(userIdentifier, dateEnd, licenseIdentifier));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
